export const getDecodedHTMLContent = (htmlText: any) => {
  const parser = new DOMParser()
  const result = parser.parseFromString(htmlText, 'text/html')
  const text = result.body.textContent
  return text
}
